import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationServiceShape } from '../lib/types/propTypes';
import { VerificationService, Segment } from '../lib/types/types';
import { getSafe } from '../lib/utils/objects';


interface TryAgainButtonComponentProps {
    verificationService: VerificationService;
}

const TryAgainButtonComponent = ({ verificationService }: TryAgainButtonComponentProps) => {
    const currentSegment = getSafe<Segment>(() => verificationService.verificationResponse.segment);

    return (
        <button
            type="button"
            className="sid-btn sid-btn-light"
            aria-label="submit"
            onClick={ () =>
                verificationService.fetchNewVerificationRequest(verificationService.programId, currentSegment, verificationService.previousViewModel)
            }
            onKeyPress={ () =>
                verificationService.fetchNewVerificationRequest(verificationService.programId, currentSegment, verificationService.previousViewModel)
            }
            tabIndex={0}
        >
            <FormattedHTMLMessage id="tryAgain" defaultMessage="Try again" />
        </button>
    );
};


TryAgainButtonComponent.propTypes = {
    verificationService: VerificationServiceShape.isRequired,
};

export { TryAgainButtonComponent };
